/**
 * Zurück-Buttons unterstützen
 */
export default function initJsBackButton() {
  [...document.querySelectorAll('.js-back-button')].forEach(elem => {
    elem.addEventListener('click', evt => {
      evt.preventDefault();
      window.history.back();
    });
  });
}
